module.exports = __webpack_public_path__ + "img/foot.b5152511.png";